import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import geoclock from '@evotempus/assets/images/geologic-clock.png';
export const HeaderLogo = () => {
    return (_jsx(React.Fragment, { children: _jsx("a", Object.assign({ id: "wiki-header-logo", href: "https://en.wikipedia.org/wiki/Geologic_time_scale", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx("img", { src: geoclock, alt: "geo-clock" }) })) }));
};
